export { default } from './VerificationForm.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/VerificationForm/index.js